import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input } from "../../../components/form";
import { Button } from "../../../components/button";

interface ICategoryForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const CategoryForm: React.FC<ICategoryForm> = ({
  loading,
  form,
  submit,
}) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input
          label="Nom"
          className="w-full"
          {...form.register("name", { required: "Nom requis" })}
          placeholder="Nom de la catégorie"
        />
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
